exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-loading-error[data-v-1a009f32]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;height:100vh;margin:auto}.a-loading-error .sf-alert[data-v-1a009f32]{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-pack:center;justify-content:center}.a-loading-error .sf-button[data-v-1a009f32]{margin:0 1em}\n", ""]);

// exports
